<!--在查询无列表数据 展示的方式-->
<template>
  <div class="null-con">
    <div class="nc-img-con" v-if="bgUrlShow!=0" >
      <img
        :src="url"
        width="95"
        height="95"
        style="top: -23px; z-index: 10"
      />
      <img src="@/assets/image/null-bg.png" width="216" height="133" />
    </div>
    <div class="nc-img-con" v-if="bgUrlShow==0" style="height:53px;"> 
      <img :src="url" alt="" style="width:134px;">
    </div>
    <p>{{ text }}</p>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: "暂无数据",
    },
    url: {
      type: String,
      default: require("@/assets/image/null-box.png"),
    },
    bgUrlShow: {
      type: String,
      default: 1,
    }
  }
};
</script>

<style lang="scss" scoped>
.null-con {
  .nc-img-con {
    position: relative;
    margin-top: 156px;
    height: 115px;
  }
  img {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  p {
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 18px;
  }
}
</style>